import { Product } from '@core/models/piramide/Product';

export class CoolerFan extends Product {
  $caracteristicas: {
    id_producto: number;
    disponible: number;
    dimensiones: number;
    cantidad: number;
    max_speed: number;
    regular_speed: number;
    LED: number;
    ColorLED: string;
    molex: number;
    Pines: number;
    max_ruido: number;
    flujo_maximo: number;
    espesor: number;
    hue_compatible: number;
    w: number;
    presion_estatica: number;
    sistema_rgb: string;
    incluye_controladora_rgb: number;
  };

  public constructor(product: Product) {
    super(product);
    if (product.id_subcategoria !== 35) {
      throw 'esto no es un coolerfan';
    }
  }
}
